import Vue from 'vue';

const EventBus = new Vue();

export const EVENTS = {
  FORM_SUBMIT: 'FORM-SUBMIT'
};

export default EventBus;
